import TwyneURL from '../form/TwyneURL';

import FormComponent from './FormComponent';

export default class TwyneURLForm extends FormComponent {
  static Pure = props => <TwyneURL {...props} />
}

TwyneURLForm.extendDefaultProps = {}
